import { ButtonProps, styled } from "@mui/material";
import ButtonBase from "./BaseButton";

interface GreenButtonProps extends ButtonProps {
  inheritHeight?: boolean;
}

const GreenButton = (props: GreenButtonProps) => {
  const { inheritHeight = true, ...rest } = props;
  return <StyledAcceptButton inheritHeight={inheritHeight} {...rest} />;
};

const StyledAcceptButton = styled(ButtonBase, {
  shouldForwardProp: (prop) => prop !== 'inheritHeight'
})<{ inheritHeight?: boolean }>(({ theme, inheritHeight }) => ({
  fontWeight: 500,
  color: "#fff",
  height: inheritHeight ? "100%" : "auto",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxSizing: "border-box",
  padding: "8px 16px",
  textDecoration: "none",
  "&": {
    backgroundColor: "var(--sub-color)",
  },
  "&:hover": {
    backgroundColor: "var(--green-800)",
    textDecoration: "none",
  },
  "&.Mui-disabled": {
    backgroundColor: "#D0D5DD",
    color: "#fff",
  },
  fontSize: 14,
  [theme.breakpoints.down("md")]: {
    fontSize: 12,
    padding: "8px 12px",
  },
}));

export default GreenButton;
